import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

function getContrastYIQ(hexcolor) {
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq >= 128 ? "#000" : "#fff";
}

const ColorItem = (props) => {
    const colorCss = { backgroundColor: props.hex };
    const textCss = { color: getContrastYIQ(props.hex) };

    return (
        <div className="color-item" style={colorCss}>
            <p style={textCss}>{props.hex}</p>
            {props.removeItem && (
                <div className="close" onClick={props.removeItem}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            )}
        </div>
    );
};

export default ColorItem;
